// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1veWi","resendInfoText":"OnGoingPaymentBox_resendInfoText__1I938"};